import { render, staticRenderFns } from "./CustomStyleLayout.vue?vue&type=template&id=44e2c403&scoped=true"
import script from "./CustomStyleLayout.vue?vue&type=script&lang=js"
export * from "./CustomStyleLayout.vue?vue&type=script&lang=js"
import style0 from "./CustomStyleLayout.vue?vue&type=style&index=0&id=44e2c403&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2c403",
  null
  
)

export default component.exports